import styled from "styled-components";

export const ContainerRemoveAccount = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
  flex-direction: column;

  background-color: #f4f4f4;
  border-radius: 8px;
  min-height: 400px;

  form {
    margin-top: 2rem;
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-between;
  }
`;


export const ColInput = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
`;

export const ContainerFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: row;
  width: 100%;
  margin-top: 10rem;

  button{
    background: #e22301; 
    border-radius: 8px; 
    width: 100%;
    max-width: 250px;
    color: white;
    height: 49px;
    font-size: 18px;
    cursor: pointer;

    &:disabled{
      background: gray; 
      cursor: not-allowed;
      font-size: 18px;
      }
  }
`
export const ContainerEmailVerification = styled.div`
  display: flex;
  gap: 30px;
  width: 80%;
  .verifyEmail{
    margin-top: 25px;
    width: 30%;
    height: 37%;
    button{
      height: 49px;
      padding: 0 !important;
    }
  }
`